import servicioNuevos from '@/services/servicio-nuevos';

const nuevos = {  
   methods: {
      nuevosConsultarCantidad(){
         return servicioNuevos.nuevosConsultarCantidad()
         .then(r=>{
            this.$loading(false);
            this.$emit("actualizarCantidadNuevos",r.data);
            return r;          
         })
         .catch(e=>{
            return e;
         })
      }
   }   
}

export default nuevos;